import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { isMobile } from 'constants';
import FlipMove from 'components/widgets/animation/flip-move';

import Ticket from './ticket';


export default function TicketGroup({ tickets, columns, updateTicket, ...passedProps }) {
  if (!tickets || !tickets.length) return null;

  const styles = { columnCount: columns };

  if (columns === 1) styles.width = `calc(${100 / 3}% - ${20 / 3 * 2}px)`;
  if (columns === 2) styles.width = `calc(${100 / 3 * 2}% - ${20 / 3}px)`;
  if (columns === 3 || isMobile) styles.width = '100%';

  return (
    <FlipMove className="ticket-group" style={styles}>
      {_.map(tickets, (ticket) =>
        <div key={ticket.id}>
          <Ticket ticket={ticket} updateTicket={updates => updateTicket({ id: ticket.id, uuid: ticket.uuid, ...updates })} {...passedProps} />
        </div>
      )}
    </FlipMove>
  );
}

TicketGroup.propTypes = {
  columns: PropTypes.number,
  tickets: PropTypes.array,
  updateTicket: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/models/ticket/ticket-group.js